import React, { useState } from "react";
import { Button } from "@aph/ui-lib-humanx";
import { DeviceInfo } from "@/interface/deviceInfo";
import styles from "./SectionHeader.module.scss";

interface SectionHeaderProps {
  title?: React.ReactNode;
  subTitle?: React.ReactNode;
  isReadMoreBtn?: boolean;
  className?: string;
  cardSpacing?: string;
  desktopAlignLeft?: boolean;
  userAgent: DeviceInfo;
}

const SectionHeader: React.FC<SectionHeaderProps> = (props) => {
  const { title, subTitle, className = "", cardSpacing = "40px 0 0 0", desktopAlignLeft, userAgent } = props;
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded: () => void = () => {
    setIsExpanded((prev) => !prev);
  };

  const isReadMoreBtn = !userAgent?.isDesktop;

  return (
    <div className={`${styles.root} ${className} ${desktopAlignLeft ? styles.desktopLeft : ""}`}>
      {title && <div className={styles.title} dangerouslySetInnerHTML={{ __html: title }} />}
      {subTitle && (
        <div
          className={`${styles.subTitle} ${isExpanded ? styles.expanded : ""}`}
          dangerouslySetInnerHTML={{ __html: subTitle }}
        />
      )}
      {isReadMoreBtn && subTitle && (
        <Button color="tertiarybaby" className={styles.btn} onClick={toggleExpanded}>
          {isExpanded ? "Read less" : "Read more"}
        </Button>
      )}
    </div>
  );
};

export default SectionHeader;
